import React from "react";
import { STATUS_LABELS, RISK_LABELS } from "../lib/api";

export function StatusBadge({ status }) {
  if (!status) return <span className="badge-base bg-neutral-800 text-neutral-400">—</span>;
  return (
    <span className={`badge-base badge-${status}`} data-testid={`status-badge-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function RiskBadge({ risk }) {
  if (!risk) return <span className="badge-base bg-neutral-800 text-neutral-400">—</span>;
  return (
    <span className={`badge-base badge-${risk}`} data-testid={`risk-badge-${risk}`}>
      {RISK_LABELS[risk] || risk}
    </span>
  );
}
